import React, { Component } from "react";
import './impressum.css';
import FontAwesomeIcon from 'react-fontawesome';

class Impressum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false
        }
    }


    toggle = (event) =>{
        let wrapper = document.getElementById('impressum');
        if(wrapper.classList.contains('active')){
            wrapper.classList.remove('active');
        }else{
            wrapper.classList.add('active');
        }
    }


    render() {
        return (
            <div id="impressum" className="impressumRoot" onClick={this.toggle}>
                <div className="toggle"><p>Impressum<i class="fa fa-solid fa-caret-down"></i></p></div>
                <div id="impressumWrapper">
                    <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
                    <p>Janes Heuberger<br />
                    Am Ziegelplatz 4<br />
                    77746 Schutterwald</p>

                    <h2>Kontakt</h2>
                    <p>E-Mail: 6.punkt.null@gmail.com</p>

                    <h2>Redaktionell verantwortlich</h2>
                    <p>Janes Heuberger</p>
                </div>
            </div>
        );
    }
}
export default Impressum;